import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import './TotalCss.css'
import './FetchData.css';
import { api_url } from "./globalFunction/global_string";
import { id } from 'date-fns/locale';

export class FetchData extends Component {
  static displayName = FetchData.name;

  constructor(props) {
    super(props);
    this.state = {
      fetchDataForTableApply: {
        parentName: "SiteApply",
        current_user_type: localStorage.getItem('login_user_type'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        local_unit_id: localStorage.getItem('login_user_unit_id'),
        user_name: localStorage.getItem('login_user_name'),
        user_id: localStorage.getItem('login_user_id'),
        
        url_addr: '',
        showModal: false,
        editModal: false,
      },
      forecasts: [],
      loading: true,
      selectedReleaseDate: '',
      vaild_date_start: '',
      vaild_date_end: '',
      id:'',
      note: '',
    };
  }

  openModal = (item) => {
    this.setState({
      showModal: true,
      id:item.id,
      selectedReleaseDate: item.release_date,
      vaild_date_start:item.vaild_date_start,
      vaild_date_end: item.vaild_date_end,
      note: item.note,
    }, () => {
      console.log('State after setting:', this.state);
    });
  };



  Delete = (id) => {
    const formData = new FormData()
    formData.append('id', id);
    fetch(api_url + '/api/Async/DeletebulletinboardData', {
      method: 'POST',
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
      },
      body: formData,
    })
      .then(response => response.json())
      .then(result => {
        //console.log(result)
        if (result.statusCode === 200) {
          this.populateWeatherData();
        } else {
          console.error('更新失敗:', result);
        }
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (localStorage.getItem('login_user_type') !== prevState.fetchDataForTableApply.current_user_type) {
      this.checkLoginStatus();
      this.populateWeatherData();
    }
  }
  
  checkLoginStatus() {
    const current_user_type = localStorage.getItem('login_user_type');
    const local_net_id = localStorage.getItem('login_user_net_id');
    const local_unit_id = localStorage.getItem('login_user_unit_id');
    const user_name = localStorage.getItem('login_user_name');
    const user_id = localStorage.getItem('login_user_id');
  
    if (current_user_type) {
      this.setState({
        fetchDataForTableApply: {
          ...this.state.fetchDataForTableApply,
          current_user_type,
          local_net_id,
          local_unit_id,
          user_name,
          user_id,
        },
      });
    }
  }
  
  openRegisterModal = () => {
    this.setState({
      showModal: true,

    });
  };
  closeRegisterModal = () => {
    this.setState({ showModal: false, editingItem: null,selectedReleaseDate: '',
    vaild_date_start: '',
    vaild_date_end: '',
    note: '', });
  };

  componentDidMount() {
    this.checkLoginStatus();
    this.populateWeatherData();
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };



  saveChanges = () => {
    
    const selectedReleaseDate = this.state.selectedReleaseDate;
    const vaild_date_start = this.state.vaild_date_start;
    const vaild_date_end = this.state.vaild_date_end;
    const note = this.state.note;
    const release_unit = this.state.fetchDataForTableApply.user_name;
    const user_id = this.state.fetchDataForTableApply.user_id;
    const id = this.state.id
    const formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('release_date', selectedReleaseDate);
    formData.append('vaild_date_start', vaild_date_start);
    formData.append('vaild_date_end', vaild_date_end);
    formData.append('note', note);
    formData.append('release_unit', release_unit);
    if  (id ===''){
      fetch(api_url + '/api/Async/InsertbulletinboardData', {
        method: 'POST',
        headers: {
          "Authorization": localStorage.getItem('accessToken'),
        },
        body: formData,
      })
      .then(response => response.json())
      .then(result => {

        if (result.statusCode === 200) {
          this.setState({
            selectedReleaseDate: '',
            vaild_date_start: '',
            vaild_date_end: '',
            note: '',
            
          });
          this.closeRegisterModal();
          this.populateWeatherData();
        } else {
          console.error('更新失敗:', result);
        }
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
    }
    else {
      formData.append('id',id)
      fetch(api_url + '/api/Async/PutbulletinboardData', {
        method: 'POST',
        headers: {
          "Authorization": localStorage.getItem('accessToken'),
        },
        body: formData,
      })
      .then(response => response.json())
      .then(result => {
        if (result.statusCode === 200) {
          this.setState({
            selectedReleaseDate: '',
            vaild_date_start: '',
            vaild_date_end: '',
            note: '',
          });
          this.closeRegisterModal();
          this.populateWeatherData();
        } else {
          console.error('更新失敗:', result);
        }
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
    }
    

    };
   renderForecastsTable(forecasts) {
    return (
      <table id='tablelabel' className='table table-striped table-bordered dt-responsive nowrap vertical-align-center' aria-labelledby="tableLabel">
        <thead>
          <tr>
            <th className='nancy_table_width10'>發佈日期</th>
            <th className='nancy_table_width25'>有效日期</th>
            <th className='nancy_table_width50'>事項</th>
            {this.state.fetchDataForTableApply.current_user_type === 'S' ? <th className='nancy_table_width15'>動作</th> : null}
          </tr>
        </thead>
        <tbody>
          {forecasts.map(forecast =>
            <tr key={forecast.id}>
              <td>{forecast.release_date}</td>
              <td>{forecast.vaild_date_start}~{forecast.vaild_date_end}</td>
              <td className="note-content">{forecast.note}</td>
              {this.state.fetchDataForTableApply.current_user_type === 'S' ?
                <td>
                  <Button type="button" color="info"  size="sm" className="mx-1 d-inline" onClick={() => this.openModal(forecast)}>編輯</Button>
                  <Button type="button" color="danger"  size="sm" className="mx-1 d-inline" onClick={() => this.Delete(forecast.id)}>刪除</Button>
                </td>
                : null}
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderForecastsTable(this.state.forecasts);

    return (

      <div className='mt-2'>
        <Row >
          <Col className="text-end">
            {this.state.fetchDataForTableApply.current_user_type === "S" && (
              <Button onClick={this.openRegisterModal}>新增</Button>
            )}
          </Col>
        </Row>
        {contents}
        <Modal isOpen={this.state.showModal} toggle={this.closeRegisterModal}>
          <ModalHeader toggle={this.closeRegisterModal}>修改資料</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="release_date" >發布日期</Label>
              <Input type='date' name='selectedReleaseDate' value={this.state.selectedReleaseDate} onChange={this.handleInputChange} min={new Date().toISOString().split('T')[0]}>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="vaild_date_start">有效日期開始</Label>
              <Input type='date' name='vaild_date_start' value={this.state.vaild_date_start} onChange={this.handleInputChange} min={new Date().toISOString().split('T')[0]}>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="vaild_date_end">有效日期結束</Label>
              <Input type='date' name='vaild_date_end' value={this.state.vaild_date_end} onChange={this.handleInputChange} min={this.state.vaild_date_start}>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="note">事項</Label>
              <Input type="textarea" name='note' value={this.state.note} onChange={this.handleInputChange} style={{ height: '20rem' }} />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveChanges}>儲存</Button>{' '}
            <Button color="secondary" onClick={this.closeRegisterModal}>取消</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
  async populateWeatherData() {
    await fetch(api_url + '/api/Auth/bulletinboardListData', {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        rows.sort((a, b) => {
          return new Date(b.release_date) - new Date(a.release_date);
        });
        this.setState({ forecasts: rows, loading: false });
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }
}

